import Api from '../../helpers/api';
import Locations from '../../helpers/locations';
import Constants from './LpConstant';

export const getLppackageDetails = (lpslug) => {

    const params = {
        lpslug,
    }
    return function (dispatch) {
        dispatch({
            type: Constants.ACTIONS.GET_LP_LOADING,
        });
        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.GET_LP_PACKAGE,
                payload: response.results[0]
            });
        };

        const errorCall = (errorResponse) => {
            console.log(errorResponse)
            dispatch({
                type: Constants.ACTIONS.GET_LP_FAIL,
                payload: errorResponse
            });
        }

        Api.doGet(Locations.Lp, params, successCall, errorCall);
    }
}

export const getLppackageAliasDetails = (lpslug) => {
    // const params = {
    //     lpslug,
    // }
    const location = `${Locations.LpAlias}${lpslug}/`
    return function (dispatch) {
        dispatch({
            type: Constants.ACTIONS.GET_LP_LOADING,                
        });
        const successCall = (response) => {
           console.log(response.package)
            dispatch({
                type: Constants.ACTIONS.GET_LP_PACKAGE,
                payload: response.package
            });
        };

        const errorCall = (errorResponse) => {
            console.log(errorResponse)
            dispatch({
                type: Constants.ACTIONS.GET_LP_FAIL,
                payload: errorResponse
            });
        }

        Api.doGet(location, {}, successCall, errorCall);
    }
}

const getCall = (body) => {

    console.log(body)
    return function (dispatch) {

        const successCall = (response) => {
            dispatch({
                type: Constants.ACTIONS.LEAD_GENRATED_SUCCESS,
                payload: response
            });
            console.log(response, "post response")
        };

        const errorCall = (errorResponse) => {
            console.log(errorResponse)
            dispatch({
                type: Constants.ACTIONS.LEAD_GENRATED_FAIL,
                payload: errorResponse
            });
        }

        Api.doPost(Locations.LeadGenration, body, successCall, errorCall);
    }
}

export default {
    getLppackageDetails,
    getLppackageAliasDetails,
    getCall
}